import React from 'react';
import { Routes, Route } from 'react-router-dom';

// pages
import Prepare from './Prepare';
import Call from './Call';

function Telephony() {
  return (
    <Routes>
      <Route path="prepare" element={<Prepare />} />
      <Route path="call" element={<Call />} />
    </Routes>
  );
}

export default Telephony;
